import routerOptions0 from "/nuxtWeb/node_modules/.pnpm/nuxt@3.21.4_@parcel+watcher@2.5.6_@types+node@25.6.0_@vue+compiler-sfc@3.5.33_cac@6.7.1_abb8b274e22302619c04cd6b77bd2d51/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}